import { useSelector } from 'react-redux';
import { selectDelivery } from '@store/order/selectors';
import { isZasilkovnaId, isDpdId, isPplId } from '@components/utils';
import { PacketaScript } from '@pages/order/payment-shipping/packeta-script/PacketaScript';
import { DpdScript } from '@pages/order/payment-shipping/dpd-script/DpdScript';
import { PplScript } from '@pages/order/payment-shipping/ppl-script/PplScript';



const Dispatch = () => {

	const delivery = useSelector(selectDelivery);

	if (!delivery) return (
		<></>
	)

	if (!isZasilkovnaId(delivery.id) && !isDpdId(delivery.id) && !isPplId(delivery.id)) return (
		<></>
	)

	return (
		<div className='dispatch-point-section'>

			{isZasilkovnaId(delivery.id) &&
				<PacketaScript />}

			{isDpdId(delivery.id) &&
				<DpdScript />}

			{isPplId(delivery.id) &&
				<PplScript />}

		</div>
	);
};

export default Dispatch;